import React from 'react'
import TomerGabelImg from '../../images/speakers/Tomer-Gabel.jpg'


const TomerGabel = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
        <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
					<h2>Tomer Gabel</h2>
						<div className="row">
                            <div className="col-md-6">
                                <img src={TomerGabelImg} className="img-responsive" alt="Tomer Gabel" />
                                <ul className="social-icon">
									<li><a href="https://www.linkedin.com/in/tomergabel/" target="_blank" className="fa fa-linkedin wow fadeIn"></a></li>
									<li><a href="https://twitter.com/tomerg" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
								</ul>
                            </div>
                         <div className="col-md-5">
							<p>
                            A programming junkie and computer history aficionado, Tomer's been around the block a few times before settling in at WeWork. <br />
                            Over the years he's built any number of (predominantly back-end) systems, cofounded two major Israeli user groups (Java.IL and Underscore), organized an annual Scala conference (Scalapeño) and is a recurring speaker at software conferences. <br />
                            He secretly still hopes to realize his childhood dream of becoming a lion tamer.
							</p>
                           </div>
                        </div>
                        <div className="row">
							<h4>Talk: Microservices: A retrospective</h4>
							<p>
                            SOA has been around for decades, and its latest iteration - microservices - for a while now. Just five years ago microservices were hip, dominating the agenda at conferences; now we almost take them for granted. With microservice-focused conference talks losing steam, the time is ripe to consider what we, as an industry, can learn from the microservice disruption; more importantly, we have a golden opportunity to consider what we have yet to learn!
                            <br /><br />
                            In this talk I'll analyse the lessons hammered into us as we've adopted microservices, and take a hard look at the challenges I believe we still struggle with as an industry. If you're not doing microservices you'll leave the room knowing where the pains will come from; if you are, you will leave with ideas and leads on mitigating these pains.
							</p>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default TomerGabel


// WEBPACK FOOTER //
// ./src/pages/speakers/tomer-gabel.js